import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import { getUtmParamsForQrCodeUrl } from '../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    join_code: PropTypes.string,
    is_web_gallery: PropTypes.bool,
    album_subtype: PropTypes.string.isRequired,
  }).isRequired,
};

const MAX_ALBUM_FOLDER_NAME_SIZE_FOR_REFIT = 30;

const FlyerPrintTemplateNoWGJoinCode = ({ albumFolder }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);

  return (
    <Fragment>
      <p
        className="marketing-material-flyer-header-copy"
        style={{
          fontSize:
            (albumFolder?.name?.length ?? 0) >
            MAX_ALBUM_FOLDER_NAME_SIZE_FOR_REFIT
              ? '4vw'
              : undefined,
        }}
      >
        Don&apos;t Miss a Moment from <br />
        {albumFolder?.name}!
      </p>

      <p className="marketing-material-flyer-target-enroll-copy">
        Text this code to 735-343:
        <br />
        <strong className="text-uppercase">{albumFolder.join_code}</strong>
      </p>

      <div
        className="marketing-material-flyer-qrcode-secondary pf-eo-qrcode"
        style={{
          top: '56%',
          right: `calc(50% - ${Math.round((width * 0.25 ?? 500) / 2)}px)`,
        }}
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url: albumFolder.onboarding_short_url,
            albumFolder,
          })}
          size={width * 0.25 ?? 500}
        />
      </div>
      <img
        ref={templateRef}
        src={getAsset(
          '/marketing-material/MARKETING_FLYER_GENERAL_1_PF_EO.png',
        )}
        alt=""
      />
    </Fragment>
  );
};

FlyerPrintTemplateNoWGJoinCode.propTypes = propTypes;

export default FlyerPrintTemplateNoWGJoinCode;
